const HAS_TIMEZONE_SUFFIX = /(?:Z|[+-]\d{2}:?\d{2})$/i;

export function parseUtcDateTime(value?: string | null): Date | null {
  if (!value) {
    return null;
  }

  const normalizedValue = HAS_TIMEZONE_SUFFIX.test(value) ? value : `${value}Z`;
  const date = new Date(normalizedValue);

  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatUtcDateTimeForUser(value?: string | null): string {
  const date = parseUtcDateTime(value);

  if (!date) {
    return '-';
  }

  return new Intl.DateTimeFormat('es-AR', {
    dateStyle: 'short',
    timeStyle: 'short'
  }).format(date);
}
